import { render } from "./TwelveFooter.vue?vue&type=template&id=200d0b24"
import script from "./TwelveFooter.vue?vue&type=script&lang=js"
export * from "./TwelveFooter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__